const contractor = {
  wizardTitle: "רישום קבלן",
  wizardSubtitle: "הגשת בקשה לרישום בפנקס הקבלנים",
  stepBusiness: "פרטי עסק",
  stepLicense: "רישיון וסיווג",
  stepDocuments: "מסמכים",
  stepServiceArea: "אזור שירות",
  stepReview: "סקירה ואישור",
  businessName: "שם העסק",
  businessId: "ח.פ / ע.מ",
  phone: "טלפון",
  email: "אימייל",
  address: "כתובת",
  licenseNumber: "מספר רישיון קבלן",
  classificationTier: "דרגת סיווג",
  classificationCategory: "ענפי סיווג",
  insuranceCert: "תעודת ביטוח",
  licenseScan: "סריקת רישיון",
  documentsDesc: "העלה מסמכים תומכים (אופציונלי — ניתן להוסיף אחר כך)",
  licenseExpiry: "תוקף רישיון",
  insuranceExpiry: "תוקף ביטוח",
  serviceAreas: "אזורי שירות",
  back: "חזרה",
  next: "הבא",
  submit: "הגש בקשה",
  submissionSuccess: "הבקשה הוגשה בהצלחה!",
  submissionSuccessDesc: "הצוות שלנו יבדוק את הבקשה ויחזור אליך בהקדם.",
  confirmationNumber: "מספר אישור",
} as const;
export default contractor;
